import 'reflect-metadata';

export const JSON_API_RELATIONSHIP_DECORATOR_KEY = 'JSON_API_RELATIONSHIP_DECORATOR_KEY';

export default function JsonApiRelationship(targetType: string) {
  return function (target: any, propertyKey: string) {
    const classConstructor = target.constructor;
    const metadata =
      Reflect.getMetadata(JSON_API_RELATIONSHIP_DECORATOR_KEY, classConstructor) || {};
    metadata[propertyKey] = targetType;
    Reflect.defineMetadata(JSON_API_RELATIONSHIP_DECORATOR_KEY, metadata, classConstructor);
  };
}
